import * as React from "react";
import PropTypes from "prop-types";
import EditParentSeriesWizard from "../AdminEdit/EditParentSeriesWizard";
import { editRegularShift } from "../../../api/apiEndpoints";
import Spinner from "../../../components/loading/Spinner";
import AddChildShift from "./AddChildShift";
import NatTime from "../../../components/text/NatTime";
import ClientName from "../../../components/links/ClientName";

class EditParentSeries extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			formValues: {
				Notes: props.shift.Notes,
				AdminPay: props.shift.AdminPay,
				TravelPay: props.shift.TravelPay,
				HrmApproval: props.shift.HrmApproval
			},
			submittingUpdate: false,
			saveError: null,
			addingDay: false
		};
	}

	submitSeriesPatch = () => {
		return editRegularShift({
			Id: this.props.shift.Id,
			...this.state.formValues
		});
	};

	handleSubmitUpdate = () => {
		this.setState({
			submittingUpdate: true,
			saveError: null
		});

		this.submitSeriesPatch()
			.then(() => {
				this.props.handleCloseModal();
			})
			.catch(() => {
				this.setState({
					submittingUpdate: false,
					saveError:
						"Your change may still be saving. Refresh the page to check before trying again."
				});
			});
	};

	seriesFormValuesCallback = formValues => {
		if (formValues === "done") {
			// Block re-submits: the save takes ~30s server-side and a second
			// PATCH queues behind the first on a table-level lock.
			if (this.state.submittingUpdate) {
				return;
			}

			this.handleSubmitUpdate();
			return;
		}

		this.setState({
			formValues: formValues
		});
	};

	render() {
		if (this.state.addingDay) {
			return (
				<div>
					<h4 className="heading">Add a day to this block</h4>
					<AddChildShift
						shift={this.props.shift}
						handleCloseModal={this.props.handleCloseModal}
					/>
					<button
						className="btn-clear color-primary"
						style={{ marginTop: 8 }}
						onClick={() => this.setState({ addingDay: false })}
					>
						Back to the shift settings
					</button>
				</div>
			);
		}
		const days = (this.props.shift.Multiday || []).slice().sort((a, b) => {
			return new Date(a.StartTime) - new Date(b.StartTime);
		});
		return (
			<div>
				<h4 className="heading">Days in this block</h4>
				<div style={{ marginBottom: 10 }}>
					{days.map(day => (
						<div key={day.Id}>
							<NatTime startTime={day.StartTime} endTime={day.EndTime} /> -{" "}
							<ClientName clientId={day.ClientId} />
						</div>
					))}
					<button
						className="btn btn-primary"
						style={{ marginTop: 8 }}
						onClick={() => this.setState({ addingDay: true })}
					>
						<i className="fas fa-plus" /> Add a day to this block
					</button>
					<div style={{ fontSize: 12, marginTop: 4 }}>
						Adds a day to this block only. A repeating series' other weeks are not changed.
					</div>
				</div>

				<h4 className="heading">Edit Shift</h4>
				<div className="row">
					<EditParentSeriesWizard
						showNotes={true}
						showTravelPay={true}
						showAdminFee={true}
						showHrmApproval={true}
						parentSeries={this.state.formValues}
						handleCloseModal={this.props.handleCloseModal}
						saving={this.state.submittingUpdate}
						onChangeCallback={this.seriesFormValuesCallback}
					/>
					<Spinner loading={this.state.submittingUpdate} />
					{this.state.saveError && (
						<div className="alert alert-warning">{this.state.saveError}</div>
					)}
				</div>
			</div>
		);
	}
}

EditParentSeries.propTypes = {
	handleCloseModal: PropTypes.func.isRequired,
	shift: PropTypes.object
};

export default EditParentSeries;
